<div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex flex-col gap-4">
      <div>
        <label for="tenant-name" class="block text-sm/6 font-medium text-gray-700">
          {{ 'tenantForm.name.label' | translate }}
        </label>
        <div class="mt-1">
          <div
            [class]="
              'flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 focus-within:outline-2 focus-within:-outline-offset-2 ' +
              (form.controls.name.invalid && form.controls.name.touched
                ? 'outline-red-600 focus-within:outline-red-600'
                : 'outline-gray-300 focus-within:outline-main')
            ">
            <input
              type="text"
              id="tenant-name"
              formControlName="name"
              class="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
          </div>
          @if (form.controls.name.invalid && form.controls.name.touched) {
            @if (form.controls.name.hasError('required')) {
              <p class="mt-1 text-sm text-red-600">
                {{ 'tenantForm.name.required' | translate }}
              </p>
            }
            @if (form.controls.name.hasError('uniqueName')) {
              <p class="mt-1 text-sm text-red-600">
                {{ 'tenantForm.name.unique' | translate }}
              </p>
            }
          }
        </div>
      </div>

      <div>
        <label for="webclient-url" class="block text-sm/6 font-medium text-gray-700">
          {{ 'tenantForm.webClientUrl.label' | translate }}
        </label>
        <div class="mt-1">
          <div
            [class]="
              'flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 focus-within:outline-2 focus-within:-outline-offset-2 ' +
              (webClientValidationState() === 'invalid'
                ? 'outline-red-600 focus-within:outline-red-600'
                : 'outline-gray-300 focus-within:outline-main')
            ">
            <input
              type="text"
              id="webclient-url"
              formControlName="webClientUrl"
              class="w-full p-2 border-0 focus:outline-none text-gray-900"
              [placeholder]="'tenantForm.webClientUrl.placeholder' | translate" />
            @if (webClientValidationState() === 'validating') {
              <svg
                class="animate-spin h-5 w-5 text-main mr-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4" />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
            }
          </div>
          @if (webClientValidationState() === 'invalid') {
            <p class="mt-1 text-sm text-red-600">{{ webClientValidationError() }}</p>
          }
        </div>
      </div>

      <details class="group">
        <summary
          class="flex list-none items-center gap-1 text-sm/6 font-medium text-gray-700 cursor-pointer select-none">
          <svg
            class="h-4 w-4 text-gray-400 transition-transform group-open:rotate-90"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
          {{ 'tenantForm.advancedUrls.label' | translate }}
        </summary>

        <div class="mt-4 flex flex-col gap-4">
          <div>
            <label for="contentprovider-url" class="block text-sm/6 font-medium text-gray-700">
              {{ 'tenantForm.apiUrl.label' | translate }}
            </label>

            <div class="mt-1">
              <div
                [class]="
                  'flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 focus-within:outline-2 focus-within:-outline-offset-2 ' +
                  (form.controls.apiUrl.invalid && form.controls.apiUrl.touched
                    ? 'outline-red-600 focus-within:outline-red-600'
                    : 'outline-gray-300 focus-within:outline-main')
                ">
                <input
                  type="text"
                  id="contentprovider-url"
                  formControlName="apiUrl"
                  class="w-full p-2 border-0 focus:outline-none text-gray-900" />
                @if (urlValidationState() === 'validating') {
                  <svg
                    class="animate-spin h-5 w-5 text-main mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4" />
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                }
              </div>
              @if (form.controls.apiUrl.invalid && form.controls.apiUrl.touched) {
                <p class="mt-1 text-sm text-red-600">
                  {{ 'tenantForm.apiUrl.required' | translate }}
                </p>
              }
              @if (urlValidationState() === 'invalid') {
                <p class="mt-1 text-sm text-amber-600">{{ urlValidationError() }}</p>
              }
            </div>
          </div>

          <div>
            <label for="tenant-sts" class="block text-sm/6 font-medium text-gray-700">
              {{ 'tenantForm.stsUrl.label' | translate }}
            </label>
            <div class="mt-1">
              <div
                [class]="
                  'flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 focus-within:outline-2 focus-within:-outline-offset-2 ' +
                  (form.controls.stsUrl.invalid && form.controls.stsUrl.touched
                    ? 'outline-red-600 focus-within:outline-red-600'
                    : 'outline-gray-300 focus-within:outline-main')
                ">
                <input
                  type="text"
                  id="tenant-sts"
                  formControlName="stsUrl"
                  class="w-full p-2 border-0 focus:outline-none text-gray-900" />
                @if (stsValidationState() === 'validating') {
                  <svg
                    class="animate-spin h-5 w-5 text-main mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4" />
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                }
              </div>
              @if (form.controls.stsUrl.invalid && form.controls.stsUrl.touched) {
                <p class="mt-1 text-sm text-red-600">
                  {{ 'tenantForm.stsUrl.required' | translate }}
                </p>
              }
              @if (stsValidationState() === 'invalid') {
                <p class="mt-1 text-sm text-amber-600">{{ stsValidationError() }}</p>
              }
            </div>
          </div>
        </div>
      </details>

      <div class="flex gap-4 justify-end">
        <button
          type="button"
          routerLink="/tenants"
          class="px-4 py-2 text-sm font-medium rounded-lg border-2 border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-colors">
          {{ 'tenantForm.cancel' | translate }}
        </button>
        <button
          type="submit"
          [disabled]="form.invalid"
          class="px-4 py-2 text-sm font-medium rounded-lg border-2 border-main bg-main text-white hover:bg-main-mid disabled:opacity-50 disabled:cursor-not-allowed disabled:border-gray-100 transition-colors">
          {{ 'tenantForm.save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
